"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResultList = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const if_defined_js_1 = require("lit/directives/if-defined.js");
const repeat_js_1 = require("lit/directives/repeat.js");
const common_1 = require("@/components/common");
const list_item_styles_1 = require("@/components/common/list-item/list-item.styles");
const shared_styles_1 = require("@/stylesheets/shared.styles");
const utils_1 = require("@/utils");
require("@/components/common");
/**
 * 검색어와 일치하는 페이지로 가는 링크 목록.
 * 결과를 누르면 그 페이지로 이동하므로 menu가 아닌 list로 읽히고, 각 링크가 저마다 Tab 순서를 갖는다.
 * heading은 목록 밖에 제목 요소로 렌더하고 목록에 aria-labelledby로 연결한다.
 */
let SearchResultList = class SearchResultList extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.results = [];
        this.headingId = (0, utils_1.uniqueId)('search-result-heading');
    }
    render() {
        return (0, lit_1.html) `
      ${this.renderHeading()}
      <mm-list-item-group
        gap="0"
        aria-labelledby=${(0, if_defined_js_1.ifDefined)(this.heading ? this.headingId : undefined)}
      >
        ${(0, repeat_js_1.repeat)(this.results, result => result.href, result => this.renderResult(result))}
      </mm-list-item-group>
    `;
    }
    renderHeading() {
        if (!this.heading)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-heading level="5" id=${this.headingId}>${this.heading}</mm-heading>
    `;
    }
    renderResult(result) {
        return (0, lit_1.html) `
      <div>
        <a href=${result.href}>
          <mm-list-item
            size="medium"
            icon=${common_1.ICON_NAMES.SEARCH}
            label=${result.label}
            description=${result.description ?? ''}
          ></mm-list-item>
        </a>
      </div>
    `;
    }
};
SearchResultList.styles = [
    shared_styles_1.resetStyles,
    list_item_styles_1.interactiveRowStyles,
    (0, lit_1.css) `
      :host {
        display: flex;
        flex-direction: column;
        gap: var(--space-1);
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], SearchResultList.prototype, "heading", void 0);
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], SearchResultList.prototype, "results", void 0);
SearchResultList = __decorate([
    (0, decorators_js_1.customElement)('mm-search-result-list')
], SearchResultList);
exports.SearchResultList = SearchResultList;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VhcmNoLXJlc3VsdC1saXN0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsic2VhcmNoLXJlc3VsdC1saXN0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUFvRDtBQUNwRCxxREFBMkQ7QUFDM0QsZ0VBQXdEO0FBQ3hELHdEQUFpRDtBQUVqRCxnREFBZ0Q7QUFDaEQscUZBQXFGO0FBQ3JGLCtEQUF5RDtBQUN6RCxtQ0FBa0M7QUFDbEMsK0JBQTRCO0FBUTVCOzs7O0dBSUc7QUFFSSxJQUFNLGdCQUFnQixHQUF0QixNQUFNLGdCQUFpQixTQUFRLGdCQUFVO0lBQXpDOztRQWEyQixZQUFPLEdBQW1CLEVBQUUsQ0FBQTtRQUMzQyxjQUFTLEdBQUcsSUFBQSxnQkFBUSxFQUFDLHVCQUF1QixDQUFDLENBQUE7SUF3Q2hFLENBQUM7SUF0Q0MsTUFBTTtRQUNKLE9BQU8sSUFBQSxVQUFJLEVBQUE7UUFDUCxJQUFJLENBQUMsYUFBYSxFQUFFOzs7MEJBR0YsSUFBQSx5QkFBUyxFQUFDLElBQUksQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLFNBQVMsQ0FBQzs7VUFFcEUsSUFBQSxrQkFBTSxFQUNOLElBQUksQ0FBQyxPQUFPLEVBQ1osTUFBTSxDQUFDLEVBQUUsQ0FBQyxNQUFNLENBQUMsSUFBSSxFQUNyQixNQUFNLENBQUMsRUFBRSxDQUFDLElBQUksQ0FBQyxZQUFZLENBQUMsTUFBTSxDQUFDLENBQ3BDOztLQUVKLENBQUE7SUFDSCxDQUFDO0lBRU8sYUFBYTtRQUNuQixJQUFJLENBQUMsSUFBSSxDQUFDLE9BQU87WUFBRSxPQUFPLGFBQU8sQ0FBQTtRQUVqQyxPQUFPLElBQUEsVUFBSSxFQUFBO2lDQUNrQixJQUFJLENBQUMsU0FBUyxJQUFJLElBQUksQ0FBQyxPQUFPO0tBQzFELENBQUE7SUFDSCxDQUFDO0lBRU8sWUFBWSxDQUFDLE1BQW9CO1FBQ3ZDLE9BQU8sSUFBQSxVQUFJLEVBQUE7O2tCQUVHLE1BQU0sQ0FBQyxJQUFJOzs7bUJBR1YsbUJBQVUsQ0FBQyxNQUFNO29CQUNoQixNQUFNLENBQUMsS0FBSzswQkFDTixNQUFNLENBQUMsV0FBVyxJQUFJLEVBQUU7Ozs7S0FJN0MsQ0FBQTtJQUNILENBQUM7O0FBcERNLHVCQUFNLEdBQUc7SUFDZCwyQkFBVztJQUNYLHVDQUFvQjtJQUNwQixJQUFBLFNBQUcsRUFBQTs7Ozs7O0tBTUY7Q0FDRixDQUFBO0FBQzJCO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQztpREFBaUI7QUFDWjtJQUEvQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxTQUFTLEVBQUUsS0FBSyxFQUFFLENBQUM7aURBQTZCO0FBYmpELGdCQUFnQjtJQUQ1QixJQUFBLDZCQUFhLEVBQUMsdUJBQXVCLENBQUM7R0FDMUIsZ0JBQWdCLENBc0Q1QjtBQXREWSw0Q0FBZ0IifQ==